import { MenuIcon, SettingsIcon } from '@assets/icons';
import { AvatarImg, Logo } from '@assets/images';
import { useAppDispatch, useAppSelector } from '@hooks';
import {
  AppBar,
  Avatar,
  Drawer,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@mui/material';
import { logout, showConfirm, toggleMenu } from '@redux/actions';
import { Routes } from '@utils/constants';
import { FC, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DrawerMenu from '../Menu/Menu';
import './Header.scss';

const Header: FC = () => {
  const dispath = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openMenu } = useAppSelector((state) => state.app);
  const { account } = useAppSelector((state) => state.auth);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenSettings = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSettings = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispath(
      showConfirm({
        title: 'common.logout',
        content: 'common.logout_confirm',
        onConfirm: () => dispath(logout()),
      }),
    );
  };

  return (
    <AppBar position="sticky" className="Header">
      <Drawer open={openMenu} onClose={() => dispath(toggleMenu())}>
        {<DrawerMenu />}
      </Drawer>
      <Toolbar className="HeaderToolbar">
        <div className="HeaderToolbar__logo">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu-close"
            onClick={() => dispath(toggleMenu())}
          >
            <MenuIcon />
          </IconButton>
          <img src={Logo} onClick={() => navigate(Routes.DASHBOARD)} />
        </div>
        <div className="HeaderToolbar__settings">
          <Avatar alt={account?.username} src={AvatarImg} />
          <Typography variant="h4">Hi, {account?.username}</Typography>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenSettings}
            color="inherit"
          >
            <SettingsIcon />
          </IconButton>
          <Menu
            id="HeaderMenu"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleCloseSettings}
          >
            <MenuItem onClick={handleLogout}>{t('common.logout')}</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
